import CtaWorkleap from "../assets/cta-workleap.png";
import CtaPixelUnion from "../assets/cta-pixel-union.svg";
import G2LeaderBadge from "../assets/g2-leader-badge.png";
import G2CrowdRating from "../assets/g2-crowd-rating.png";
import GartnerRating from "../assets/gartner-rating.png";

const utm = (content: string) =>
    `?utm_source=whatismytenantid&utm_campaign=whatismytenantid&utm_medium=bloc&utm_content=${content}`;

export const CtaBanner = () => (
    <section className="cta-banner">
        <div className="cta-banner__copy">
            <h2 className="cta-banner__title">
                Don’t just migrate it,<br />ShareGate it.
            </h2>
            <div className="cta-banner__actions">
                <a
                    className="cta-banner__btn"
                    href={`https://sharegate.com/demo${utm("demo")}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    Request a demo
                </a>
                <a
                    className="cta-banner__btn cta-banner__btn--ghost"
                    href={`https://home.sharegate.com/register${utm("trial")}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    Start a free trial
                </a>
            </div>
        </div>
        <div className="cta-banner__media" aria-hidden="true">
            <img className="cta-banner__bg" src={CtaWorkleap} alt="" />
            <img className="cta-banner__mask" src={CtaPixelUnion} alt="" />
            <img className="cta-banner__leader" src={G2LeaderBadge} alt="" />
            <img className="cta-banner__rating cta-banner__rating--g2" src={G2CrowdRating} alt="" />
            <img className="cta-banner__rating cta-banner__rating--gartner" src={GartnerRating} alt="" />
        </div>
    </section>
);
